export const env = {
  supplierApiUrl:
    import.meta.env.VITE_SUPPLIER_API_URL?.trim() ||
    "https://api.kithub24.com/supplier",
  analyticsAiUrl:
    import.meta.env.VITE_ANALYTICS_AI_URL?.trim() ||
    "https://api.kithub24.com/analytics-ai",
  aiValidationApiUrl:
    import.meta.env.VITE_AI_VALIDATION_API_URL?.trim() ||
    "https://api.kithub24.com/ai-validation",
  firebaseVapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY?.trim() || "",
  demoMode: __DEMO_MODE__,
  version: __APP_VERSION__,
} as const;
